function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 23"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.13 7.18a6.87 6.87 0 1113.74 0 6.87 6.87 0 01-13.75 0zm13.06 8.25h-1.23a9.63 9.63 0 01-9.92 0H4.8A4.81 4.81 0 000 20.24v1.03c0 .57.46 1.03 1.03 1.03h19.94c.57 0 1.03-.46 1.03-1.03v-1.03a4.81 4.81 0 00-4.81-4.81z",
  clipRule: "evenodd"
})));